exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-dropzone[data-v-51f8f44d] {\n  min-height: 138px;\n}\n.dropzone-custom-content[data-v-51f8f44d] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n.dropzone-custom-title[data-v-51f8f44d] {\n  margin-top: 0;\n  color: #00b782;\n}\n.subtitle[data-v-51f8f44d] {\n  font-weight: bold;\n}\n", ""]);

// exports
